import "./participants.css";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import refreshIcon from "../../assets/RefreshIcon.svg";



import Tabmenu, { TabMenuType } from "../../components/tabmenu/Tabmenu";
import { convertTimeString, getCurrentDate } from "../../utils/TimeUtils";
import MasterButton, { ButtonLayoutType, ButtonSize, ButtonVariation } from "../../components/button/MasterButton";
import InputfieldWithPlaceholder, { InputfieldType } from "../../components/inputfieldwithplaceholder/Inputfieldwithplaceholder";
import { SearchIcon } from "../../assets/SearchIcon";
import { ClearIcon } from "../../assets/ClearIcon";

import TableViews from "../../components/tableViews/tableViews";

import { useSelector , useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../context/store';

import { fetchAnomalousParticipantDetails, reloadAnomalousParticipantsDetails } from '../../context/content/participantPages/anomalousParticipantsSlice';
import { fetchUnAnomalousParticipantDetails, reloadUnAnomalousParticipantsDetails } from '../../context/content/participantPages/unAnomalousParticipantsSlice';
import { fetchUnattachedParticipantDetails, reloadUnattachedParticipantsDetails } from '../../context/content/participantPages/unattachedParticipantsSlice';

import Skeleton from "../../components/skeleton/Skeleton";


// Create an API to fetch the values from the data
// Also - this needs to be updated during search 
type TabMenuValues = {
  [key: string]: number;
};

const ParticipantsTabMenuValues: TabMenuValues = {
  Anomalous: 0,
  Stable: 0,
  Unassigned: 0
};

type SensorDetails = {
  participantID: string; // Example: 'LAS001NNN'
  healthScore: number; // Value from 1 to 10
  sensorID: string; // 12 digit Hexadecimal Format
  sensorBattery: number; // Value from 0 - 100
  lastSyncTime: string; // Time data type
  firstSyncTime: string; // Time data type
  provisionTime: string; // Time data type
  organizationName: string; // Example: 'org-A'
  studyName: string; // Example: 'study-A'
  pinnedStatus: boolean;
  syncStatus: string;
};

// Convert the above into JSON using json.stringify() and 

type TableOptions = {
  tabName: string;
  isStudySelected: boolean;
  isStudyOrgSelected: boolean;
  networkError: boolean;
  isLoading: boolean;
}

const TableOptions : TableOptions = {
  tabName: "Participants",
  isStudySelected: false,
  isStudyOrgSelected: true,
  networkError: false,
  isLoading: false,
}



interface ParticipantDetailsObject {
  [key: string]: SensorDetails[];
}

const ParticipantDetailsStore : ParticipantDetailsObject = {
  AnomalousDetailsArray : [],
  StableSensorDetailsArray : [],
  UnassignedSensorDetailsArray : []
}

function filterString(input: string): string {
  if (input == "All Studies") {
    return "";
  } else {
    return input;
  }
}

// Write code to update the subtab in query string 

const Participants = () => {

  const [refreshDate, setRefreshDate] = useState(getCurrentDate());

  const [isLoading, setLoading] = useState(true);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [searchActive, setSearchActive] = useState(false);
  
  const [searchQuery, setSearchQuery] = useState("");

  const scrollRef = useRef<HTMLDivElement>(null);

  const [placeholderValue, setplaceholderValue] = useState("");

  const [isRefreshing, setRefereshing] = useState(false);

  const [studyNameFromStore, setStudyNameFromStore] = useState("");
  const [studyOrgFromStore, setStudyOrgFromStore] = useState("");

  const dispatch: AppDispatch = useDispatch(); 

  const anomalousParticipantsDetailsUpdates = useSelector((state : RootState) => state.anomalousParticipantsDetails);
  const unAnomalousParticipantsDetailsUpdates = useSelector((state : RootState) => state.unAnomalousParticipantsDetails);
  const unAttachedParticipantsDetailsUpdates = useSelector((state : RootState) => state.unAttachedParticipantsDetails);

  useEffect(() => {
    ParticipantDetailsStore['AnomalousDetailsArray'] = anomalousParticipantsDetailsUpdates['sensors']
    ParticipantDetailsStore['StableSensorDetailsArray'] = unAnomalousParticipantsDetailsUpdates['sensors']
    ParticipantDetailsStore['UnassignedSensorDetailsArray'] = unAttachedParticipantsDetailsUpdates['sensors']

  }, [anomalousParticipantsDetailsUpdates, unAnomalousParticipantsDetailsUpdates, unAttachedParticipantsDetailsUpdates])

  useEffect(() => {
    dispatch(fetchAnomalousParticipantDetails());
    dispatch(fetchUnAnomalousParticipantDetails());
    dispatch(fetchUnattachedParticipantDetails());
  }, [dispatch]);













  const search = (query: string) => {
    console.log("Search Query:", query);
    setSearchQuery(query);
  };


  // Initialize an empty array of any type
  const [items, setItems] = useState<SensorDetails[]>([]);

  // const filteredData = items.filter((item : SensorDetails) => {
  //   return (
  //     item.participantID.toString().toUpperCase().includes(searchQuery.toUpperCase()) ||
  //     item.sensorID.toString().toUpperCase().includes(searchQuery.toUpperCase())
  //   );
  // });

  const storeStudy = useSelector((state: RootState) => state.studyInfo);
  // const networkStatus = useSelector((state: RootState) => state.networkError);

  const [tableOptions, setTableOptions] = useState<TableOptions>({
    tabName: "Participants",
    isStudySelected: false,
    isStudyOrgSelected: false,
    networkError: false,
    isLoading: false,
  });
  
  useEffect(()=> {

    let StudyOrg = storeStudy.study.StudyOrg
    let StudyName = storeStudy.study.StudyName

    setStudyOrgFromStore(StudyOrg);
    setStudyNameFromStore(StudyName);

    if (storeStudy) {
      if(StudyOrg == "All Studies"){
        setTableOptions({
          tabName: "Participants",
          isStudySelected: false,
          isStudyOrgSelected: false,
          networkError: false,
          isLoading: true,
        });
        setplaceholderValue("Enter ID, Org or Study")
      }else if(StudyName == ""){
        setTableOptions({
          tabName: "Participants",
          isStudySelected: false,
          isStudyOrgSelected: true,
          networkError: false,
          isLoading: true,
        });
        setplaceholderValue("Enter ID or Study")
      }else{
        setTableOptions({
          tabName: "Participants",
          isStudySelected: true,
          isStudyOrgSelected: true,
          networkError: false,
          isLoading: true,
        });
        setplaceholderValue("Enter ID")
      }
    }


  }, [storeStudy])


  useEffect(() => {

    if(selectedTabIndex === 0){
      setItems(filteredData.AnomalousDetailsArray)
    }else if(selectedTabIndex === 1){
      setItems(filteredData.StableSensorDetailsArray)
    }else if(selectedTabIndex === 2){
      setItems(filteredData.UnassignedSensorDetailsArray)
    }

  }, [selectedTabIndex, searchQuery, anomalousParticipantsDetailsUpdates, unAnomalousParticipantsDetailsUpdates, unAttachedParticipantsDetailsUpdates, studyNameFromStore, studyOrgFromStore] )


  let filteredData = Object.fromEntries(
    Object.entries(ParticipantDetailsStore).map(([key, ParticipantDetailsArray]) => {
      const filteredArray = ParticipantDetailsArray.filter((item: SensorDetails) => {
        return (
          item.participantID.toString().toUpperCase().includes(searchQuery.toUpperCase()) ||
          item.sensorID.toString().toUpperCase().includes(searchQuery.toUpperCase()) ||
          (tableOptions.isStudyOrgSelected === false && item.organizationName.toString().toUpperCase().includes(searchQuery.toUpperCase())) ||
          (tableOptions.isStudySelected === false && item.studyName.toString().toUpperCase().includes(searchQuery.toUpperCase())) 
          // item.organizationName.toString().toUpperCase().includes(filterString(storeStudy.study.StudyOrg).toUpperCase()) ||
          // item.studyName.toString().toUpperCase().includes(filterString(storeStudy.study.StudyName).toUpperCase()) 
        );
      });
      return [key, filteredArray];
    })
  );


  filteredData = Object.fromEntries(
    Object.entries(filteredData).map(([key, ParticipantDetailsArray]) => {
      const filteredArray = ParticipantDetailsArray.filter((item: SensorDetails) => {
        if(studyOrgFromStore.toUpperCase() == "ALL STUDIES"){
          return true;
        }else if(studyNameFromStore.toUpperCase() == ""){
          return(
            item.organizationName.toString().toUpperCase().includes(studyOrgFromStore.toUpperCase())
          )
        }else{
          return (
            item.studyName.toString().toUpperCase().includes(studyNameFromStore.toUpperCase()) &&
            item.organizationName.toString().toUpperCase().includes(studyOrgFromStore.toUpperCase())
          );
        }
      });
      return [key, filteredArray];
    })
  );



  useEffect(() => {
    if(items.length > 0){
      console.log("Loading should stop",items)
      setLoading(false)
    }
  }, [items.length])


  const reloadData = async () => {
    console.log("Reloading Data from Database");
  
    setRefereshing(true);
  
    try {
      // Dispatch the action to reload data
      await dispatch(reloadAnomalousParticipantsDetails());
      await dispatch(reloadUnAnomalousParticipantsDetails());
      await dispatch(reloadUnattachedParticipantsDetails());
      // Wait for data to reload and then update the refresh date
      setRefreshDate(getCurrentDate());
    } catch (error) {
      console.error("Error reloading data:", error);
    } finally {
      // Ensure isRefreshing is set to false regardless of success or failure
      setRefereshing(false);
    }
  };

  

    return (
      <>
        <div className="participants-page">
          <div className="tab-header">
            <div className="left-section">
              <div className="title headline-small">Participants</div>
              
              <Tabmenu
                isDisabled={false}
                isLoading={isLoading}
                items={[
                  {
                    type: TabMenuType.PENDING,
                    value: filteredData.AnomalousDetailsArray.length,
                    title: "Anomalous",
                  },
                  {
                    type: TabMenuType.ACTIVE,
                    title: "Stable",
                    value: filteredData.StableSensorDetailsArray.length,
                  },
                  {
                    type: TabMenuType.UNASSIGNED,
                    value: filteredData.UnassignedSensorDetailsArray.length,
                    title: "Unassigned",
                  },
                ]}
                onTabSelected={(index) => {
                  if (index !== selectedTabIndex) {
                    if (!searchActive) {
                      // loadSingleTab(selectedStudy, index);
                    }
                    setSelectedTabIndex(index);
                    scrollRef.current?.scrollTo({ top: 0, left: 0, behavior: "smooth" }); // Makes the current tab to scroll smoothly to top
                  }
                }}
              ></Tabmenu>
        
            </div>

            <div className="quick-actions">
              <div className={`body-small refresh-date ${isRefreshing ? "loading" : ""}`}>
                {isRefreshing ? "Refreshing..." : `Updated on ${refreshDate}`}
              </div>
              <MasterButton
                options={{
                  layoutType: ButtonLayoutType.IconLabel,
                  label: "Refresh",
                  variation: ButtonVariation.Outlined,
                  icon: refreshIcon,
                  size: ButtonSize.Medium,
                }}
                onClick={() => {
                  console.log("master button refresh");
                  reloadData()
                  // loadData(selectedStudy); // !!!!!!!!!!!!! Need to use the studyInfo state here to get the relevant study and load the data through the API
                }}
              ></MasterButton>

            <InputfieldWithPlaceholder
              collapsable={true}
              leftIcon={<SearchIcon fill={getComputedStyle(document.documentElement).getPropertyValue("--on-surface-variant")}></SearchIcon>}
              rightActionIcon={<ClearIcon fill={getComputedStyle(document.documentElement).getPropertyValue("--on-surface-variant")} />}
              onRightActionClicked={() => {
                setSearchQuery("");
                search("");
                setSearchActive(false);
              }}
              value={searchQuery}
              onValueChanged={(value) => {
                if (value !== "") {
                  setSearchActive(true);
                } else {
                  setSearchActive(false);
                }
                setSearchQuery(value);
                search(value);
              }}
              type={searchActive && items.length === 0 ? InputfieldType.Error : InputfieldType.Normal}
              placeholderValue={placeholderValue}
            ></InputfieldWithPlaceholder>

            </div>

          </div>

          <div className="content">

            <div className="static-place-holder"></div>
            <div className="table-info-section">
            {isLoading ? (
              <Skeleton></Skeleton>
              ) : (
                <>
                  <span className="display-small">{items.length}</span>
                  <span>&nbsp;</span>
                  <span className="title-small">Participants</span>
                </>
              )}
            </div>

            <div className="separator"></div>

            <TableViews TableDataArray={items} TableOptions={tableOptions}></TableViews>

          </div>

        </div>
      </>
    );
};

export default Participants;